// extracted by mini-css-extract-plugin
export default {"heading3":"heading3-module--heading3--RWGtu","primary":"heading3-module--primary--AY0UE","secondary":"heading3-module--secondary--HOxKN","bold":"heading3-module--bold--EKwNp"};